export default function PaymentGateway() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Payment Gateway
            </div>
            <div className="page-sub" id="page-sub">
              Configure online payment gateway for tenant payments
            </div>
          </div>
          <div className="topbar-right" id="topbar-right">
            <button className="btn btn-primary" onclick="openPgwModal(null)">
              + Add Gateway
            </button>
          </div>
        </div>
        <div className="content" id="content-area">
          <div className="info-box" style={{ marginBottom: 16 }}>
            ✅ <strong>Razorpay</strong> is active. Tenants with insufficient
            coins will be redirected to the payment gateway.
          </div>
          {/* GATEWAY LIST */}
          <div className="card mb16">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 14,
              }}
            >
              <div className="card-title" style={{ margin: 0 }}>
                Configured Gateways
              </div>
              <button
                className="btn btn-primary"
                onclick="openOwnerPgwModal(null)"
              >
                + Add Gateway
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Gateway</th>
                    <th>Merchant ID</th>
                    <th>Environment</th>
                    <th>Active</th>
                    <th>Intent</th>
                    <th>Added On</th>
                    <th style={{ minWidth: 160 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="sn-col">1</td>
                    <td>
                      <div
                        style={{
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        💳 Razorpay
                      </div>
                    </td>
                    <td
                      style={{
                        fontFamily: "monospace",
                        fontSize: 11,
                        maxWidth: 160,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title="rzp_live_VnViv0WoDTUGsB"
                    >
                      rzp_live_VnViv0WoDTUGsB
                    </td>
                    <td>
                      <span className="badge badge-gray">TestMode</span>
                    </td>
                    <td>
                      <label
                        className="toggle"
                        title="Active — click to deactivate"
                      >
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleOwnerPG(1,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <span className="badge badge-teal">Yes</span>
                    </td>
                    <td style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
                      Jan 10, 2024
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openOwnerPgwModal(1)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleOwnerPG(1,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteOwnerPG(1)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleOwnerPG(1,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">2</td>
                    <td>
                      <div
                        style={{
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        💰 Cashfree
                      </div>
                    </td>
                    <td
                      style={{
                        fontFamily: "monospace",
                        fontSize: 11,
                        maxWidth: 160,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title="21333874b01e35d9280279"
                    >
                      21333874b01e35d9280279
                    </td>
                    <td>
                      <span className="badge badge-gray">Production</span>
                    </td>
                    <td>
                      <label
                        className="toggle"
                        title="Inactive — click to activate"
                      >
                        <input
                          type="checkbox"
                          onchange="toggleOwnerPG(2,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <span className="badge badge-gray">No</span>
                    </td>
                    <td style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
                      Mar 5, 2024
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openOwnerPgwModal(2)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon green"
                          onclick="toggleOwnerPG(2,true)"
                        >
                          <span className="tip">Activate</span>▶
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteOwnerPG(2)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-success"
                          onclick="toggleOwnerPG(2,true)"
                        >
                          ▶ Activate
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* ROUTING TABLE (parity with SaaS) */}
          <div className="card mb16">
            <div className="flex-between mb12">
              <div>
                <div className="card-title" style={{ margin: 0 }}>
                  Payment Gateway Routing
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginTop: 3,
                  }}
                >
                  Route each payment mode to a primary gateway with an automatic
                  fallback if the primary fails.
                </div>
              </div>
              <button
                className="btn btn-primary"
                onclick="showToast('All routing rules saved!','success')"
              >
                💾 Save All Routes
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th style={{ minWidth: 170 }}>Payment Mode</th>
                    <th style={{ width: 80 }}>Enabled</th>
                    <th style={{ minWidth: 160 }}>Primary Gateway</th>
                    <th style={{ minWidth: 160 }}>Fallback Gateway</th>
                    <th style={{ minWidth: 150 }}>Min. Success Rate</th>
                    <th style={{ minWidth: 100 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>📱</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            UPI
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Unified Payments Interface
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="ownerRoutingConfig['UPI'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['UPI'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['UPI'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option selected="">Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['UPI'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for UPI!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for UPI routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>💳</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            CC
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Credit Card
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="ownerRoutingConfig['CC'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['CC'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['CC'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option selected="">Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['CC'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for CC!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for CC routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>🏦</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            DC
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Debit Card
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="ownerRoutingConfig['DC'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['DC'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['DC'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option selected="">Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['DC'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for DC!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for DC routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>🌐</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            Netbanking
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Net Banking
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          onchange="ownerRoutingConfig['Netbanking'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['Netbanking'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['Netbanking'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['Netbanking'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for Netbanking!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for Netbanking routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>👛</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            Wallet
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Digital Wallets
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          onchange="ownerRoutingConfig['Wallet'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['Wallet'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['Wallet'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['Wallet'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for Wallet!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for Wallet routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: 16 }}>📅</span>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            EMI
                          </div>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            EMI / Installments
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          onchange="ownerRoutingConfig['EMI'].enabled=this.checked"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['EMI'].primary=this.value"
                      >
                        <option selected="">Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <select
                        style={{ fontSize: 12, padding: "5px 8px", width: 140 }}
                        onchange="ownerRoutingConfig['EMI'].fallback=this.value"
                      >
                        <option value="">— No Fallback —</option>
                        <option>Razorpay</option>
                        <option>Cashfree</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        defaultValue={90}
                        min={0}
                        max={100}
                        style={{ fontSize: 12, padding: "5px 8px", width: 68 }}
                        onchange="ownerRoutingConfig['EMI'].successRateThreshold=this.value"
                      />
                      <span
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        % min
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button
                          className="btn btn-xs btn-primary"
                          onclick="showToast('Routing saved for EMI!','success')"
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-xs"
                          onclick="showToast('Test transaction initiated for EMI routing.','info')"
                        >
                          Test
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="two-col">
            <div className="card">
              <div className="card-title">Routing Logic</div>
              <div
                style={{
                  fontSize: 12,
                  color: "var(--text-secondary)",
                  lineHeight: "1.8",
                }}
              >
                <p style={{ marginBottom: 8 }}>
                  When a tenant initiates a payment:
                </p>
                <ol
                  style={{
                    paddingLeft: 18,
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                  }}
                >
                  <li>
                    Platform detects the <strong>payment mode</strong> (UPI, CC,
                    DC, Netbanking, etc.)
                  </li>
                  <li>
                    Checks if routing is <strong>enabled</strong> for that mode
                  </li>
                  <li>
                    Attempts the transaction via the{" "}
                    <strong>Primary Gateway</strong>
                  </li>
                  <li>
                    If primary fails or drops below threshold → retries via{" "}
                    <strong>Fallback Gateway</strong>
                  </li>
                  <li>
                    Transaction result is logged for success rate tracking
                  </li>
                </ol>
              </div>
            </div>
            <div className="card">
              <div className="card-title">
                Gateway Success Rates (Last 7 Days)
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>💳 Razorpay</span>
                  <span style={{ fontWeight: 600, color: "#BA7517" }}>94%</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "94%", background: "#BA7517" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>💰 Cashfree</span>
                  <span style={{ fontWeight: 600, color: "#BA7517" }}>88%</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "88%", background: "#BA7517" }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* ADD/EDIT GATEWAY MODAL */}
          <div className="modal-overlay" id="modal-owner-pgw">
            <div className="modal" style={{ width: 560 }}>
              <div className="modal-header">
                <div className="modal-title" id="owner-pgw-modal-title">
                  Add Payment Gateway
                </div>
                <button
                  className="modal-close"
                  onclick="closeModal('modal-owner-pgw')"
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <input type="hidden" id="owner-pgw-id" />
                <div className="form-grid">
                  <div className="form-group">
                    <label>Gateway</label>
                    <select id="owner-pgw-name">
                      <option>Razorpay</option>
                      <option>Cashfree</option>
                      <option>PayTM</option>
                      <option>ICICI UPI</option>
                      <option>CCAvenue</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Environment</label>
                    <select id="owner-pgw-env">
                      <option>TestMode</option>
                      <option>Production</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Merchant ID *</label>
                    <input
                      type="text"
                      id="owner-pgw-mid"
                      placeholder="Enter Merchant ID"
                    />
                  </div>
                  <div className="form-group">
                    <label>Merchant Key *</label>
                    <input
                      type="text"
                      id="owner-pgw-mkey"
                      placeholder="Enter Merchant Key / Secret"
                    />
                  </div>
                  <div
                    className="form-group full"
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 16,
                      padding: "10px 0",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 12,
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        id="owner-pgw-active"
                        defaultChecked=""
                      />{" "}
                      Active
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 12,
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      <input type="checkbox" id="owner-pgw-intent" /> Allow
                      Intent (UPI Deep Link)
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn" onclick="closeModal('modal-owner-pgw')">
                  Cancel
                </button>
                <button className="btn btn-primary" onclick="saveOwnerPgw()">
                  Save Gateway
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
